export const EditorApiEndpoints = {
  GetEmpresasCliente: 'filtros/empresas-cliente',
  GetMenorCompetencia: 'filtros/menor-competencia',
  ObterProcessamentosEditaveis: 'arquivos/editaveis',
  GetArquivoEditavel: 'arquivos/editavel',
  GetBlocoCategoria: 'categoria/bloco-categoria',
  GetRegistroCategoria: 'categoria/registro-categoria',
  GetStatusArquivo: 'arquivos/status',
  GetCodigoRegistros: 'categoria/registro-categoria/',
  GetCamposPorRegistro: 'registro/',
  DeleteRegistro: 'registro/',
  EditarRegistro: 'registro/',
  AdicionarRegistro: 'registro/',
  SolicitarEdicao: 'arquivos/solicitar',
  CancelarEdicao: 'arquivos/cancelar',
  ReprocessarArquivo: 'arquivos/reprocessar',
  FinalizarEdicao: 'arquivos/finalizar',
};
